import React, { useState } from 'react';
import { Box, Heading, VStack, HStack, Text, Button, FormControl, FormLabel, Input, Table, Thead, Tbody, Tr, Th, Td, useToast } from '@chakra-ui/react';
import { useQuery, useMutation } from 'react-query';
import { api } from '../services/api';
import { useLanguage } from '../contexts/LanguageContext';
import LanguageSelector from '../components/LanguageSelector';

const SettingsLanguage = () => {
  const { t, currentLanguage, changeLanguage, clearAllTranslationCache } = useLanguage();
  const toast = useToast();
  const [transFilter, setTransFilter] = useState('');

  const { data: transData, refetch: refetchTrans } = useQuery(['translations', currentLanguage], () =>
    api.get(`/api/language/${currentLanguage}`).then(res => res.data.data.translations),
    { 
      enabled: true,
      refetchOnMount: true,
      refetchOnWindowFocus: true,
      staleTime: 0,
      cacheTime: 0
    }
  );

  const updateTransMutation = useMutation(({ key, value }) => api.put(`/api/language/translations/${encodeURIComponent(key)}`, { language: currentLanguage, value }), {
    onSuccess: () => { refetchTrans(); toast({ title: t('common.success'), description: t('settings.updated_success'), status: 'success' }); },
  });

  const handleLanguageChange = async (newLanguage) => {
    await changeLanguage(newLanguage);
    toast({ title: t('common.success'), description: t('settings.updated_success'), status: 'success' });
  };

  return (
    <Box>
      <Heading size="lg" mb={6}>{t('settings.language') || 'Language'}</Heading>

      <VStack align="start" spacing={6}>
        <VStack align="start" spacing={4} w="100%">
          <HStack>
            <Heading size="md">{t('settings.language') || 'Language'}</Heading>
          </HStack>
          <Box w="100%">
            <LanguageSelector size="sm" showLabel={true} onChange={handleLanguageChange} />
          </Box>
          <Text fontSize="sm" color="gray.600">{t('settings.language.current')}: {t(`settings.language.${currentLanguage}`)}</Text>
          <Button size="sm" variant="outline" colorScheme="orange" onClick={() => { clearAllTranslationCache(); toast({ title: t('common.success'), description: t('settings.cache_cleared') || 'Cache cleared', status: 'success' }); }}>
            {t('settings.clear_cache') || 'Clear Cache'}
          </Button>
        </VStack>

        <VStack align="start" spacing={4} w="100%">
          <Heading size="md">{t('settings.translation_editor') || 'Translation Editor'}</Heading>
          <HStack w="100%">
            <FormControl>
              <FormLabel>{t('common.search') || 'Search'}</FormLabel>
              <Input value={transFilter} onChange={(e) => setTransFilter(e.target.value)} />
            </FormControl>
          </HStack>
          <Box w="100%" maxH="360px" overflowY="auto" borderWidth="1px" borderRadius="md" p={2}>
            <Table size="sm" variant="simple">
              <Thead>
                <Tr>
                  <Th>{t('common.key') || 'Key'}</Th>
                  <Th>{t('common.value') || 'Value'}</Th>
                  <Th></Th>
                </Tr>
              </Thead>
              <Tbody>
                {Object.entries(transData || {})
                  .filter(([k]) => !transFilter || k.toLowerCase().includes(transFilter.toLowerCase()))
                  .slice(0, 200)
                  .map(([key, value]) => (
                    <Tr key={key}>
                      <Td whiteSpace="nowrap">{key}</Td>
                      <Td>
                        <Input defaultValue={value} onBlur={(e) => updateTransMutation.mutate({ key, value: e.target.value })} />
                      </Td>
                      <Td></Td>
                    </Tr>
                  ))}
              </Tbody>
            </Table>
          </Box>
        </VStack>
      </VStack>
    </Box>
  );
};

export default SettingsLanguage;
